export default __webpack_public_path__ + "static/media/adrian.eeac97e4.png";